var $ = jQuery;

$(window).load(function () {
    $("#store-menu-a11y, #a11y-help-button, #store-menu-ally-mobile").click(function () {
        $(this).parent().toggleClass("hover");
        $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
    });

    $(".global-keyboard-click").keyup(function (event) {
        if (event.which == "13") {
            $(this).click();
        }
    });

    $("#account-link").keydown(function (event) {
        if (event.key == ' ') {
            $(this).parent().toggleClass("hover");
            $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
            event.preventDefault();
        }
    });


    //   Menu code start
    var mainMenuId = "ul.main-menu-desktop";

    // 	$(mainMenuId+" li").attr("role", "none");
    $(mainMenuId + " li > a").attr({ "aria-describedby": "space-desc", 'aria-expanded': "false" });
    //   aria-describedby="space-desc"
    // 	$(mainMenuId+", "+ mainMenuId+" ul").attr("role", "menu");

    $(mainMenuId + " > li > a").focus(function (event) {
        $(mainMenuId + " > li").removeClass('focus');
        $(mainMenuId + " > li > a").attr("aria-expanded", false);
    });

    $(mainMenuId + " > li > a").keydown(function (event) {
        const key = event.key;
        switch (key) {
            case "ArrowLeft":
                $(this).parent().prev().find('> a').focus();
                event.preventDefault();
                break;
            case "ArrowRight":
                $(this).parent().next().find('> a').focus();
                event.preventDefault();
                break;
            case " ":
                if ($(this).attr("aria-expanded") == "false") {
                    if ($(this).parent().hasClass("has-children")) {

                        $(this).attr("aria-expanded", "true");
                        $(this).parent().addClass("focus");
                        event.preventDefault();
                    }
                } else {
                    if ($(this).parent().hasClass("has-children")) {
                        $(this).attr("aria-expanded", "false");
                        $(this).parent().removeClass("focus");
                        event.preventDefault();
                    }
                }
                break;
        }

    });
  
  $(mainMenuId + " > li ul > li > a").keydown(function (event) {
        const key = event.key;
        switch (key) {
            case "ArrowUp":
                $(this).parent().prev().find('> a').focus();
                event.preventDefault();
                break;
            case "ArrowDown":
                $(this).parent().next().find('> a').focus();
                event.preventDefault();
                break;
            case " ":
                if ($(this).attr("aria-expanded") == "false") {
                        $(this).attr("aria-expanded", "true");
                        $(this).parent().addClass("focus");
                        event.preventDefault();
                    
                } else {
                        $(this).attr("aria-expanded", "false");
                        $(this).parent().removeClass("focus");
                        event.preventDefault();
                    
                }
                break;
        }

    });
//   Menu Code End
  async function checkElement(selector) {
    while (document.querySelector(selector) === null) {
      await new Promise((resolve) => requestAnimationFrame(resolve));
    }

    return document.querySelector(selector);
  }
  
  var labels = [
    {selector:"#header-desktop nav", label:"Main"},
    {selector: "#shopify-section-footer nav", label:"Footer"},
    {selector: ".mobile-menu-header nav", label:"Mobile Main"}
  ];
  
  labels.forEach(function(single){
    $(single.selector).attr("aria-label", single.label);
  });

  $("#a11y-slider-button").click(function(){
    setTimeout(function(){
      $(".js-ajax-cart .ajax-cart-header > h2").attr("tabindex", -1);
      $(".js-ajax-cart .ajax-cart-header > h2").focus();
      }, 500);
  });
  
  $(".js-ajax-cart .ajax-cart-header > button.button-reset").click(function(){
    $("#a11y-slider-button").focus();
  });
  
  $(".js-ajax-cart-items > div").each(function(){
 var label = $(this).find(".ajax-cart-item-title").text().trim();
    $(this).find(".ajax-cart-item-remove-button").attr("aria-label", "Remove item from cart - "+label);
    $(this).find('[data-behavior="decrement"]').attr("aria-label", "Decrease Quantity - "+label);
    $(this).find('[data-behavior="increment"]').attr("aria-label", "Increase Quantity - "+label);
    $(this).find('[data-behavior="update-line"]').attr("aria-label", "Quantity - "+label);
  });
  
  $('[data-menu-item-handle="shop-all"]').each(function(){
    var label = $(this).parents().filter(".shopify-section.dropdown-container").prev().text().trim();
    $(this).attr("aria-label", $(this).text().trim()+" - "+ label);
  });
  
  $(".svg-arrow-right").attr("aria-hidden", true);
  $("#bv-carousel > .fm-btn-left").attr("aria-label", "Previous Slide");
  $("#bv-carousel > .fm-btn-right").attr("aria-label", "Next Slide");
  $(".dropdown-left-panel .spacer, .dropdown-left-panel .triangle").attr("aria-hidden", true);
  $("ul.dropdown-left-panel").attr("role", "list");
  
  $("#a11y-address-toggle").click(function(){
    $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false")
  });
  
  $(".wishlistpage .product .image").each(function(){
    var alt = $(this).next().find('.product_title').text().trim();
    $(this).find("> a > img").attr("alt", alt);
  });
  
  $(".product-thumbnail .thumbnail-hover-image").attr("alt", "");
  
  $(".js-next-arrow-collection-decor-products-slider").click(function(){
    $(this).prev().find('.slick-list > div.slick-track > div.slick-current[aria-hidden="false"] a.thumbnail-image-link').focus();
  })
  
  $(".js-next-arrow-collection-decor-products-slider").each(function(){
    $(this).attr({"role":"button", "tabindex":"0", "aria-label":"Next Product"});
    $(this).keyup(function(event){
      if(event.keyCode == "13"){
        $(this).click();
      }      
    });
  });
  
  $("#a11y-breadcrumb-list > li:last-child").attr("aria-current", true);
  
  
  async function checkElement(selector) {
    while (document.querySelector(selector) === null) {
      await new Promise((resolve) => requestAnimationFrame(resolve));
    }

    return document.querySelector(selector);
  }
  
  $("#add-to-cart-button").click(function(){
    checkElement(".ajax-cart:not(.is-closed)").then(function(elem){
      $(elem).find(".ajax-cart-header h2").attr("tabindex", "-1");
      
      setTimeout(function(){
        $(elem).find(".ajax-cart-header h2").focus();
        console.log("focus ....");
      }, 1000);
//       console.log($(elem).find(".ajax-cart-header button.button-reset").first(),"Visible...");
    })      
  });
  
  $("#a11y-last-element").focus(function(){    
      $(".a11y-first-element").focus();
  });
  
  $('.quantity-wrapper [data-behavior="decrement"]').attr("aria-label", "Decrease Quantity by 1");
  $('.quantity-wrapper [data-behavior="increment"]').attr("aria-label", "Increase Quantity by 1");
  
  $(".a11y-expand-menu").click(function(){
    $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
  });
  
  
  
  console.log("A11y Patched...");
  
  
});